import React from 'react';

import { Button, Result } from 'antd';

import { FormattedMessage, useNavigate } from '@umijs/max';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Result
      extra={(
        <Button onClick={() => { navigate('/'); }} type="primary">
          <FormattedMessage id="pages.404.buttonText" />
        </Button>
      )}
      status="404"
      subTitle={<FormattedMessage id="pages.404.subTitle" />}
      title="404"
    />
  );
};

export default NotFound;
